import { BackendGrade, Grade, mapBackendGradeToGrade } from './Grade';
import {
  BackendSchoolSubject,
  mapBackendSchoolSubjectToSchoolSubject,
  SchoolSubject,
} from './SchoolSubject';

export type GroupVisibility = Record<string, boolean>;

export type GroupStudent = {
  id: string;
  firstName: string;
  name: string;
};

export interface IGroup {
  id: string;
  name: string;
}

export type Group = {
  id: string;
  name: string;
  description: string;
  isDefault: boolean;
  grade: Grade;
  schoolSubjects?: SchoolSubject[];
  visibility?: GroupVisibility;
  students?: GroupStudent[];
};

export type NewGroup = {
  id: string;
  name: string;
  amountOfStudents: number;
  isDefault: boolean;
  isVisible: boolean;
};

export type NewGroupListItem = {
  id: string;
  title: string;
  groups: NewGroup[];
};

export type BackendGroup = {
  id: string;
  name: string;
  description: string;
  is_default: 1 | 0;
  grade: {
    data: BackendGrade;
  };
  school_subjects?: {
    data: BackendSchoolSubject[];
  };
  visibility?: {
    data: GroupVisibility;
  };
  students?: {
    data: GroupStudent[];
  };
};

export type PostGroupRequest = {
  grade_id: string;
  school_subject_id: string;
  name: string;
  description: string;
};

// TYPE GUARD

export const isGroup = (test: any): test is Group => !!(test as Group).grade;

// MAPPER

export const mapBackendGroupToGroup = (data: BackendGroup): Group => ({
  id: data.id,
  name: data.name,
  description: data.description,
  isDefault: Boolean(data.is_default),
  grade: mapBackendGradeToGrade(data.grade.data),
  schoolSubjects: data.school_subjects
    ? data.school_subjects.data.map(mapBackendSchoolSubjectToSchoolSubject)
    : undefined,
  students: data.students ? data.students.data : undefined,
  visibility: data.visibility ? data.visibility.data : undefined,
});

export const getGroupsMapper = (response: any): Group[] =>
  response.data
    .map(mapBackendGroupToGroup)
    .sort((a: Group, b: Group) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));

export const groupCanSeeTrajectoryMapper = (response: {
  data: { status: boolean };
}): { status: boolean } => response.data;

export interface IBookGroup {
  id: string;
  label: string;
  amountOfStudents: number;
  isDefault: boolean;
}
